module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "section_chapter--num_3--seq_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_105845-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  })]), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_105845-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675095_toc"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("CHAPTER THREE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("ANGELO’S JOURNEY was uneventful. He was halted several times by German soldiers, but the gift of a bottle or two of wine quickly persuaded them that he was fully entitled to travel where he liked; and the two drivers, of whom he had been somewhat afraid, showed clearly their desire to be friendly, and before very long were telling him their troubles.")]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00002"
    }
  }, [_vm._v("To avoid driving in the dark they spent the night in a villa – one of the Count’s smaller properties – on the eastern shore of Lake Bolsena, and there, after they had all drunk a good deal, the Czech and the Russian very earnestly sought his advice. They were both anxious to desert, and they wanted the help of someone who could guide them through the mountains to the southernmost parts of Italy, which, as they knew, had now been liberated by the English. Did Angelo know of such a person? Or would he himself show them the way?")]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00003"
    }
  }, [_vm._v("For a long time they discussed the technique of desertion, as they had learnt it from the legendary exploits of those who had succeeded and the sad tales of their friends who had failed in the attempt; and Angelo promised, with much repetition, that when they returned to Rome he would introduce them to the most reliable accomplices that could be found. Then, having embraced each other warmly, they retired to sleep. They dreamt of happiness, and early in the morning resumed their journey.")]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00004"
    }
  }, [_vm._v("It was an hour or so short of noon when they turned the last corner on the steeply climbing road to Pontefiore, and saw, like a crown of coloured stone on the hill-top, the old castle and the tightly gathered village. A narrow "), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("ravine divided the southern slope of the hill, and this, in one noble arch, was spanned by an ancient bridge whose abutments, at the proper season of the year, were overhung by blossoming trees. Even in Tuscany, where a handsome view is the merest commonplace, Pontefiore was notable for its dignified yet gentle beauty, and there was little wonder that Angelo, prone as he was to weeping, poured from his eyes a flood of delighted tears to see again its yellow roofs, the cobbled streets, and the castle tower rising among cypresses against a clear blue sky.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("He called excited greetings to some eighteen or twenty people whom he recognized in the doorways of their houses, but dutifully did not stop until he had reached the castle, and there, with a sudden dignity, he requested an indoor servant to inform the Countess of his arrival.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("She came out at once, for she did not believe in wasting time. She was small and trim, and though the prettiness of her girlhood had long since gone, much of its charm and some of its vivacity remained. Her hair was faded but her eyes were bright, and she still spoke Italian with an English accent. Had she spoken English, indeed, her accent would have been that of Yorkshire. She had formerly been a school-teacher in Bradford, and she had first met the Count in the railway station at Florence, during a holiday-fortnight that should have been devoted to the art of the Renaissance. She had won immediately while waiting for a train to Pisa – the Count’s most passionate interest, and though their early friendship had been greatly troubled, and scarred by tragedy, she now, after twenty years of marriage, enjoyed his profound respect and the assurance, generally from a distance, of his enduring affection.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("‘So you’ve come back safe and sound after all?’ she said to Angelo. ‘Well, I’m glad to see you. How long have you been away?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("‘Three years, madam.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("‘And now, I hope, you’re ready to do some honest work for a change?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘No, madam, I can’t do anything of that sort. I am still in the army, you see.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Haven’t you had enough of it yet?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Oh, more than enough!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Has it done you any good?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘None at all, so far as I am aware. It has taught me, indeed, that I shall never be a good soldier, but I was pretty sure of that before they called me up. Because, of course, I have not the "), _c('i', [_vm._v("dono di coraggio")]), _vm._v(".’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Don’t you think you should keep that to yourself?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘How can I, when all my actions reveal it? – But I am forgetting my duty. Here is a letter from Don Agesilas, who asked me to tell you that he is very well, though his hair is turning a little grey.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("The Countess read the letter quickly, for she had no interest in the art of correspondence, but was merely impatient to learn the news. Then she remarked, ‘He’s behaving quite sensibly, for a change. But where could he have got two lorry-loads of flour at a time like this?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘How should I know, madam?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00020"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘He says that you can explain everything.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("Angelo thought for a moment, and then said with a certain hesitation, ‘Since all our soldiers in Africa have been taken prisoner, they are being fed by the English, and so our Government has no use for the food that was ready to be sent to them. And I remember, now, hearing that it was to be sold quickly, before it went bad, and that Don Agesilas had bought some flour for a small price. A very small price, I think.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00022"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Well, it will come in handy, there’s no doubt of that. And you brought the pictures too?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00023"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Yes, madam.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Then we’ll get them unpacked at once.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("But Angelo, blushing a little and speaking very rapidly, asked leave to go now on business of his own, and being pressed to explain it, admitted that he was burning with desire to see Lucrezia, his boyhood’s sweetheart.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00026"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘You mean Lucrezia Donati, whose father sells charcoal?’ ")]), _c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("asked the Countess. ‘But she was only a chit of a girl when you left here.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘I was not very old myself.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00028"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Has she been writing to you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Yes, three or four times.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("The Countess was about to ask another question, but checked herself and looked at Angelo in doubt, then tightened her lips to a line of thin severity and thought again, and finally said, ‘Be kind to her, Angelo.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Be sure of that,’ cried Angelo, laughing loudly and happily. ‘I’ll be as kind to her as she will let me, and all I hope is that she will be one half as kind to me.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("He turned to go, but saw at that moment a young man who had newly come in to the hall and stood now, as if uncertain where to go, at the far end of it. He had a fair complexion and light brown hair, a lively look, and small neat features. He was about the same height and figure as Angelo himself. He stood a moment longer, then swiftly turned and went out again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Who is that?’ asked Angelo. ‘I have not seen him here before.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Italy nowadays is full of people whom no one has ever seen before,’ said the Countess, ‘and sometimes your best course will be to look the other way when you meet them, and then forget about them.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘That does not seem very courteous.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00036"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Not to see a man who doesn’t want to be seen is the very height of courtesy,’ said the Countess.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00037"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘But you are quite right! I had not thought of it in that way,’ said Angelo. ‘And you can be sure of this: that as soon as I clap eyes on Lucrezia I shall forget everything else in the world – except your kindness to me, which I shall always remember.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00038"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("Nearly everybody in the village wanted him to stop and talk. The women sitting in their doorways hailed him and asked for news of their sons and husbands who had gone with him to Africa, and men crossed the road to greet him and ask him to drink wine with them. But Angelo ")]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("put them off, one and all, saying there would be plenty of time for gossip, but now he wanted to see Lucrezia. Where was Lucrezia Donati? he demanded. At the washing-place, they told him, at the end of the village.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("He started to run, and though the way was downhill he was out of breath when he arrived and saw the girls and the women bending over the great stone trough in which they were soaping and wringing and beating their linen. It was a charming and familiar scene, and even while his eyes were searching for Lucrezia, and his lungs labouring for breath, he took the greatest pleasure in it nor wholly denied an errant wish to embrace, not his sweetheart only, but all these brisk and buxom creatures. How gaily they chattered, and how lovely was their laughter and the sound of the splashing of water! And there, in the middle of the row, was one with the prettiest pair of legs he had ever seen, so properly plump, as smooth as a chestnut and almost as brown, then paler behind the knee where the soft skin dimpled, and pale above – for now she was stooping forward and rubbing the linen so vigorously that her prim little bottom looked like a pair of apples when a boy is shaking the branch they grow on; and the back of her short skirt lifted higher still. White above her dimpling knees rose two entrancing columns into the modesty of occluding shadows, and really, thought Angelo, though legs and arms are the commonest things in the world, there are certain pairs of them with so remarkable a texture and shape that their effect upon the sensitive observer may be almost overwhelming.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("His heart beat so hard that he lost his breath again, and while he stood there panting, the girl with the long brown legs, conscious of someone staring at her, suddenly straightened herself and turned to see who it might be.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00041"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("Angelo’s voice was no louder than a whisper when he spoke her name. That was the first time. Then a little strength came to it, and he said ‘Lucrezia!’ as a man in a dark room might say it. But the third time his voice was so loud he might have been hailing a ship at sea.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("‘Lucrezia!’ he cried, ‘I have come home again, and you ")]), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("are more beautiful than ever! I thought it was impossible for you to be more beautiful, but you have wrought a miracle and made perfection lovelier than it was, and that is why, in the first moment that I saw you, I did not recognize you. Ο Lucrezia, let us be married immediately!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00043"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("As if by the pulling of a blind on a summer morning, joy had flushed Lucrezia’s cheeks and lighted her eyes when she first saw Angelo, and she had made a swift movement as though she meant to run straight into his arms. But then she halted, still as a statue, and her eyes grew round with fear, and she lifted a hand to her mouth like a child restraining a cry of pain. Her fingers were wrinkled, her wrists pink from the washing-trough, and drops of water, running down her arm, fell hesitantly from her elbow.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00044"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("Then Angelo, seeing her like that, laughed and embraced her, kissing her wet hands, and her startled eyes, and her warm neck. The women and the other girls, gathering in a close circle round them, laughed loudly and applauded. Some of them, impatient to hear of their own menfolk or eager for recognition, pulled Angelo by the sleeve and clapped him on the shoulder. But Angelo paid no attention, for by now Lucrezia’s arms were tightly round his neck. She was whispering endearments and a practical suggestion to go and look for some more private place where they could talk in peace.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00045"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("‘"), _c('i', [_vm._v("Pazienza")]), _vm._v("!’ he cried to the women, all of whom were now clamouring for news. ‘I shall be here for two or three days, and before I go I shall tell you everything I know about the regiment. But first of all I must talk with Lucrezia.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00046"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("They spent the rest of the day together, and Angelo had supper in the house of Lucrezia’s parents, a sturdy and honest pair who in twenty years of married life had produced eleven children without loss of interest in each other or diminution of affection for them. The youngest, a fair-haired boy of about twelve months, was remarkably vivacious, and Angelo was about to congratulate Signor Donati on such a testimony to his vigour when it occurred to him that the child might be the son of Lucrezia’s elder sister, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("who certainly had one or two of her own, and whose husband had recently been arrested on a false charge and sent to a labour battalion in Germany. Before he could make up his mind on this point, Signor Donati had refilled his glass, and the matter no longer seemed important. They drank a great deal of wine, and ate black figs and the well-cured ham of a black pig.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00047"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("In the morning Angelo had another conversation with the Countess, and the day was spent in selecting safe hiding-places for the pictures. Two were stored in a winecellar among gigantic tuns whose perfume made the mere air intoxicating, and others were laid in the dry lofts of nearby farmhouses. But the Adoration of the Shepherds, which Piero della Francesca had painted, was hung in a little-used bedroom in the castle, and this was done because Angelo argued, with a great deal of feeling and considerable eloquence, that a work of such divine perfection should not, even for its own safety, be imprisoned in darkness or humiliated by confinement in a farmhouse attic.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00048"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("‘Let it remain where it can give happiness and consolation to at least a few,’ he said. ‘There is more life and truth and beauty in this picture than you will find in forty living villages – and you would not bury what is alive? It is very seldom that a man has shown so greatly and so triumphantly his power to create, which he inherits from the Creator himself, and we should not conceal what proves quite clearly that some of us are certainly the children of God, and therefore all of us may be; for evidence of that kind is extremely rare. You can buy security at too high a price, and I say that a world which buried and forgot its Piero della Francescas would not be a world in which we could take any pride. I do not ask you to put it in some very public place, for that would be indiscreet, but hang it where those who know of its existence can go from time to time and breathe the air which it ennobles. We have a lot of bad company now in Italy, and therefore the greater need to associate with what is good.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("The Countess was not uninterested in painting, but her ")]), _c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("appreciation of it was more detached than Angelo’s. She could not share his emotion, but she was moved, none the less, by his argument. For she had her own enthusiasm.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00050"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("She was devoted to the novels of Ouida, and in every one of the several houses belonging to the Count there was a complete set of her works. Here, in Pontefiore, was the finest of them all. Bound in a soft white leather adorned with golden blossoms, it had been Ouida’s own property – the title-pages bore her signature – and poor Ouida had sold it in the sad years before her death when she was selling nearly all her treasures to feed her dogs. Now all this commotion about pictures had set the Countess to wondering if it would not be wise to put her own favourite masterpieces in hiding, and she had been cogitating what would be a good place. But when Angelo spoke so bravely about Piero’s Adoration, she decided to be equally courageous with her Ouidas; for what he said about the painter applied, in her opinion, with equal force to the novelist.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("‘Very well, then,’ she said. ‘We’ll hang the picture in the small bedroom under the tower, and lock the door of the corridor that leads to it, and trust in Providence to do whatever else is necessary. Does that satisfy you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("But Angelo made no answer. All his mind – and this had happened a hundred times before – was full of wonder at the skill with which Piero had painted the Blessed Virgin’s coif, for the pallor of her unlined forehead showed clearly through the whiteness of the lawn, and its transparent folds were as firmly shaped as the forehead itself. And what mild dignity lay in the curve of the temples, what calm assurance in the wisdom of the eyes, and though the chin, perhaps, was a little heavy, the lips were drawn with grace ineffable. – They were the very shape of Lucrezia’s, though hers were more brightly red.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Suddenly he returned to the mortal moving world about him, and with a little cry of distress exclaimed, ‘But I am late, and she is waiting for me! Oh, madam, may I leave you, for I promised to meet Lucrezia, and it is long past the time we set? Oh, please, may I go at once?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘Was she glad to see you?’ asked the Countess.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00056"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘Of course! She has been waiting three years for my return, and she has been very lonely. But now I am here to comfort her, and presently we shall be married, and neither of us will ever be lonely again.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘Hurry up,’ said the Countess. ‘If she is still waiting for you she may be feeling lonely now, and there are limits to what a girl can bear.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00058"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("So for the second day in succession Angelo left the castle at a run. In the short avenue of cypresses that led to the main gate he encountered the strange young man with light brown hair who had roused his curiosity on the day before; but now he paid no attention to him, except from the corner of his eye, and ran past as though the stranger were invisible. This is true courtesy, he thought. The stranger, indeed, paused and made a little gesture as if he were willing to talk. But it was too late. Angelo had gone.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00059"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("A pair of tall white oxen with widely sweeping horns stood on the bridge, while their driver, with Lucrezia beside him, leaned upon the parapet in contemplation of the depths below. They had their backs to Angelo, their elbows were touching, they were talking in soft voices. Roberto Carpaccio, the driver of the oxen, was a clever young man who had evaded conscription by feigning epilepsy, and taken to the hills whenever German press-gangs appeared in the neighbourhood. He was about Angelo’s age, and not ill-looking.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00060"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("Angelo spoke to them sadly. ‘Here I am,’ he said. ‘I am sorry that I am late.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00061"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘But are you late? I hadn’t noticed it,’ said Lucrezia.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘I am very late,’ said Angelo, and looked so extremely sad that Roberto laughed aloud, and laughing still bade Lucrezia a gay goodbye, called to his team, and went off in high good-humour.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00063"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘What is the matter with you?’ asked Lucrezia.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00064"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘You did not realize I was late. You were so interested in what Roberto had to say that you forgot me altogether.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00066"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Am I not allowed to talk to anyone but you? Dear Angelo, how silly you are! I never have forgotten you, and never shall.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00067"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘You are not in love with Roberto?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Not a bit.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00069"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Nor with anyone but me?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00070"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Nor with anyone but you!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00071"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Darling Lucrezia! And you never have been in love with anyone but me?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00072"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("Lucrezia put her arms round his neck, kissed him several times with the most agreeable warmth, and said, ‘What a lot of foolish questions you ask! Tell me what you have been doing all day, and why you were so dreadfully late that I remembered, all over again, how unhappy I used to be while you were in Africa.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00073"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Were you very unhappy?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00074"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Oh, terribly so!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00075"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘All the time, and every day?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘You would like me to tell you so, wouldn’t you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00077"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Well yes, in a way I should.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00078"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Would it really please you to know that I had been miserable for more than three years? With never a moment of pleasure in all that time?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘I should be very sorry for you. It would make me promise to do everything possible to give you happiness in the future, and help you to forget the past.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00080"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘But why do you make conditions? Promise now that you will!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00081"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Lucrezia, I promise.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00082"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Truly and faithfully?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00083"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Truly and faithfully! Dear Lucrezia, let us be married very soon!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00084"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("But Lucrezia pushed him away, and leaning over the parapet again, looked down into the ravine. ‘No, not yet,’ she said.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00085"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘But why not? Don Agesilas will give me leave of absence –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00086"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘I will not marry you while you are in the army, and while Italy is still at war.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00088"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘But we are no longer at war with the English. They are coming to liberate us, not to fight against us.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00089"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘You said last night that some of our soldiers are fighting against the Tedeschi, and the English certainly are fighting, and the Americans also, and they are all fighting here in Italy.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00090"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘But I shall not fight again, if I can help it. And I am so bad a soldier that Don Agesilas, I think, will let me leave the army, and then I shall come home and stay here.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00091"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Then someone else will take you away. No, Angelo, I will not marry you until the war is truly finished, for I do not want to be a wife for two or three weeks, or only for two or three days, perhaps, and then be left alone. It is not good for a girl who is newly married to be left alone.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00092"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘You mean,’ said Angelo, ‘that it would be like starting to read a new book –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00093"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Or sitting down to dinner –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00094"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘Then someone borrows the book –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00095"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘The plate is snatched away –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00096"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘You want to know what happens in the next chapter –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00097"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘You are hungrier than you were before you began –’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00098"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘But if you have strength of mind,’ said Angelo –")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00099"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘You can carry a great burden,’ said Lucrezia. ‘But there are limits.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00100"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘On every road in Italy you see women carrying enormous burdens.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00101"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("‘And their backs are bent, their faces tired, and they are old before their time. So also if you put too grievous a load upon their minds – no, Angelo. I will not do it.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00102"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("Nothing he said would change her opinion or undo her decision, and Angelo, in spite of his disappointment, became aware of a new respect for her. He even felt a little draught of fear that was somehow quite delicious. Sooner or later he would marry Lucrezia, and then he would be at the mercy of this strength she had developed in the years of absence, he would surrender himself to an unknown power. Though the prospect was alarming it was also alluring, and with some curiosity he perceived that fear is not always a deterrent to ")]), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("action. It may be, he thought, that I am a poltroon in war not merely because I am afraid of being hurt, but also because I do not enjoy fighting, neither the act of it nor the idea. For I now perceive that I am a little bit afraid of Lucrezia, yet I have no intention of running away from her. I should say not! So I am not altogether a coward, it seems.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00103"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Comforted by this reflection he accepted her refusal, and walked home with her in the darkness in a cheerful mood. It was Lucrezia, some little while later, who was reluctant to part, but now Angelo was quite firm, and with no regard for what lay upon her mind, bade her goodnight.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00104"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("He spent the following day talking to everyone in the village, the evening was passed in tender conversation with Lucrezia, and early the next morning he set off for Rome. The lorries were now laden with wine in great vessels of green glass jacketed in straw; and they arrived without misadventure.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00105"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Pleased and self-important about the safe conclusion of his mission, Angelo demanded to see the Count.")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00106"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘He is not here,’ replied a middle-aged butler. ‘Very soon after you left us, two German officers arrived, and a little while later he went away with them in a motor-car. I have not heard of him since.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00107"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘"), _c('i', [_vm._v("Dio mio")]), _vm._v("! He has not been arrested?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_105845-00108"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("‘It happened several days ago. I do not think that anyone would stay so long with the Tedeschi of his own accord,’ said the butler.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c783516c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675095_chapter_03.vue
// module id = 75
// module chunks = 0